import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/joy';

interface StatsCardProps {
  title: string;
  value: string | number;
  change: string;
  changeType: 'positive' | 'negative' | 'neutral';
  icon: React.ReactNode;
  color: 'primary' | 'success' | 'info' | 'warning' | 'danger';
}

export const StatsCard: React.FC<StatsCardProps> = ({
  title,
  value,
  change,
  changeType,
  icon,
  color
}) => {
  const getChangeColor = () => {
    switch (changeType) {
      case 'positive':
        return 'success.500';
      case 'negative':
        return 'danger.500';
      default:
        return 'text.secondary';
    }
  };

  return (
    <Card variant="outlined" sx={{ height: '100%' }}>
      <CardContent sx={{ textAlign: 'center' }}>
        <Box
          sx={{
            fontSize: '2rem',
            mb: 2,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            color: `${color}.500`,
          }}
        >
          {icon}
        </Box>
        <Typography level="h2" sx={{ mb: 1, color: `${color}.500` }}>
          {value}
        </Typography>
        <Typography level="body-md" sx={{ mb: 1, color: 'text.secondary' }}>
          {title}
        </Typography>
        <Typography 
          level="body-sm" 
          sx={{ 
            color: getChangeColor(),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 0.5
          }}
        >
          {changeType === 'positive' && '↗'}
          {changeType === 'negative' && '↘'}
          {change}
        </Typography>
      </CardContent>
    </Card>
  );
};